import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {DIALOG_DATA, DialogRef} from '@angular/cdk/dialog';
import {NgModel} from '@angular/forms';

@Component({
  selector: 'app-serial-number-modal',
  templateUrl: './serial-number-modal.component.html',
  styleUrls: ['./serial-number-modal.component.scss']
})
export class SerialNumberModalComponent implements OnInit {

  @ViewChild('serialNumberModel') serialNumberModel: NgModel;

  public serialNumber: string;

  public serialNumberLastFourDigits: string;
  public serialNumberStartString = 'JUC0000';

  constructor(
    private dialogRef: DialogRef<{ serialNumber: string; resetData?: boolean }>,
    @Inject(DIALOG_DATA) private data: {
      serialNumber: string;
    }
  ) {
    this.serialNumber = this.data.serialNumber;
  }

  ngOnInit(): void {
    if (!this.serialNumber || this.serialNumber === '') {
      this.serialNumber = this.serialNumberStartString;
      this.serialNumberLastFourDigits = null;
    } else {
      this.serialNumberLastFourDigits = this.serialNumber.slice(-4);
    }
  }

  closeModal() {
    this.dialogRef.close();
  }

  saveSerialNumber() {
    if (!this.serialNumberModel.invalid) {
      this.dialogRef.close({serialNumber: this.serialNumber});
    } else {
      this.serialNumberModel.control.markAsTouched();
    }
  }

  showError(model: NgModel) {
    return model.control.touched && model.control.invalid;
  }

  saveSerialNumberAndResetLS() {
    if (!this.serialNumberModel.invalid) {
      this.dialogRef.close({serialNumber: this.serialNumber, resetData: true});
    } else {
      this.serialNumberModel.control.markAsTouched();
    }
  }

  setUpTheWholeSerialNumber(event: any) {
    this.serialNumber = this.serialNumberStartString + this.serialNumberLastFourDigits;
  }
}
